import { ApolloCache, gql } from '@apollo/client';

export const evictOauthApplicationLists = (cache: ApolloCache<unknown>) => {
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'adminOauthApplications' });
  cache.gc();
};

export const oauthApplicationState = ({
  private: isPrivate,
  awaitingReview,
}: {
  private: boolean;
  awaitingReview: boolean;
}) => {
  if (isPrivate) return 'Private';
  if (awaitingReview) return 'Awaiting review';
  return 'Published';
};

export const ADMIN_OAUTH_APPLICATIONS_QUERY = gql`
  query AdminOauthApplications(
    $after: String
    $first: Int
    $orderBy: String
    $order: String
    $search: String
    $organizationId: ID
    $awaitingReview: Boolean
  ) {
    adminOauthApplications(
      after: $after
      first: $first
      orderBy: $orderBy
      order: $order
      search: $search
      organizationId: $organizationId
      awaitingReview: $awaitingReview
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        clientId
        redirectUri
        private
        published
        awaitingReview
        lastTokenIssuedAt
        createdAt
        organization {
          id
          name
        }
      }
    }
  }
`;

const OAUTH_APPLICATION_FIELDS = gql`
  fragment AdminOauthApplicationFields on OauthApplication {
    id
    name
    clientId
    clientSecret
    redirectUri
    scopes
    confidential
    contactEmail
    private
    published
    awaitingReview
    logoUrl
    lastTokenIssuedAt
    createdAt
    organization {
      id
      name
      publicId
    }
  }
`;

export const ADMIN_OAUTH_APPLICATION_QUERY = gql`
  query AdminOauthApplication($id: ID!) {
    adminOauthApplication(id: $id) {
      ...AdminOauthApplicationFields
    }
  }
  ${OAUTH_APPLICATION_FIELDS}
`;

export const ADMIN_CREATE_OAUTH_APPLICATION_MUTATION = gql`
  mutation AdminCreateOauthApplication(
    $input: AdminCreateOauthApplicationInput!
  ) {
    adminCreateOauthApplication(input: $input) {
      oauthApplication {
        ...AdminOauthApplicationFields
      }
      errors {
        message
      }
    }
  }
  ${OAUTH_APPLICATION_FIELDS}
`;

export const ADMIN_UPDATE_OAUTH_APPLICATION_MUTATION = gql`
  mutation AdminUpdateOauthApplication(
    $input: AdminUpdateOauthApplicationInput!
  ) {
    adminUpdateOauthApplication(input: $input) {
      oauthApplication {
        ...AdminOauthApplicationFields
      }
      errors {
        message
      }
    }
  }
  ${OAUTH_APPLICATION_FIELDS}
`;

export const ADMIN_DELETE_OAUTH_APPLICATION_MUTATION = gql`
  mutation AdminDeleteOauthApplication(
    $input: AdminDeleteOauthApplicationInput!
  ) {
    adminDeleteOauthApplication(input: $input) {
      errors {
        message
      }
    }
  }
`;
